/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CSSProperties } from "react";
import { css, cx } from "@panda/css";

import { OptimizedCosmosAssetFragment } from "../types";
import { CosmosAsset } from "../asset";

const styles = css({
	w: "full",
	h: "full",
	filter: "blur(var(--image-blur-pixels, 125px))",
	opacity: "var(--image-opacity, cover)",
	transform: "translateZ(0)",
	"& .blurred-image__img": {
		w: "full",
		h: "full",
		objectFit: "var(--image-object-fit, cover)",
	},
});

type ObjectFit = "fill" | "contain" | "cover" | "none" | "scale-down";

export interface BlurredImageProps {
	className?: string;
	image?: OptimizedCosmosAssetFragment | null;
	blurPixels?: number;
	objectFit?: ObjectFit;
	opacity?: number;
	width: number;
	height: number;
	disableAutoplay?: boolean;
}

export interface BlurredImageCssVariables extends CSSProperties {
	"--image-blur-pixels"?: string;
	"--image-object-fit"?: ObjectFit;
	"--image-opacity"?: number;
}

export const BlurredImage = ({
	className,
	image,
	blurPixels = 125,
	objectFit = "cover",
	opacity = 0.8,
	width,
	height,
	disableAutoplay = true,
}: BlurredImageProps): React.JSX.Element | null => {
	if (!image) return null;

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { overrideEmbedUrl: _unused, ...rest } = image;
	const safeImage = rest;

	const styleVars: BlurredImageCssVariables = {
		"--image-blur-pixels": `${blurPixels}px`,
		"--image-object-fit": objectFit,
		"--image-opacity": opacity,
	};

	return (
		<div className={cx("blurred-image", styles, className)} style={styleVars}>
			<CosmosAsset
				role="presentation"
				alt=""
				className="blurred-image__img"
				asset={safeImage}
				width={width || 1792}
				height={height || 810}
				disableAutoplay={disableAutoplay}
				hideAttribution
			/>
		</div>
	);
};
